import angular from 'angular'
import React from 'react'
import { reactular } from '@vendhq/reactular'
import { useT } from '@transifex/react'
import { useVdCurrencyFilter } from '../../../ng-compat/hooks'
import {
  QuickReceipt,
  QuickReceiptListItem,
  QuickReceiptDateItem,
  QuickReceiptRegisterItem,
} from '../quick-receipt/QuickReceipt'

interface StoreCreditIssueData {
  amount: string
  date: string
  customerInfo: string
  balance: string
  type: string
  username: string
}

interface StoreCreditIssueReceiptProps {
  data: StoreCreditIssueData
}

export const StoreCreditIssueReceipt: React.FC<StoreCreditIssueReceiptProps> = ({
  data,
}) => {
  const vdCurrencyFilter = useVdCurrencyFilter()
  const t = useT()

  return (
    <QuickReceipt
      title={data.type}
      subTitle={vdCurrencyFilter(data.amount)}
      items={
        <>
          <QuickReceiptDateItem value={data.date} />
          <QuickReceiptListItem
            label={t('Customer', { _context: 'Store credit receipt label' })}
            value={data.customerInfo}
          />
          <QuickReceiptListItem
            label={t('Balance', { _context: 'Store credit receipt label' })}
            value={vdCurrencyFilter(data.balance)}
          />
          <QuickReceiptListItem
            label={t('Served By', { _context: 'Store credit receipt label' })}
            value={data.username}
          />
          <QuickReceiptRegisterItem />
        </>
      }
    />
  )
}

angular
  .module('webregister.components')
  .component(
    'wrPrintStoreCreditIssueReceipt',
    reactular(StoreCreditIssueReceipt, ['data'], 'reactWrapper')
  )
